import type { ComponentPropsWithoutRef, ElementType, Ref } from 'react'

import formStyles from '@runtime/components/ui/Form.module.scss'
import { Text } from '@runtime/components/ui/Text'

type FormLineProps = ComponentPropsWithoutRef<'div'>

export function FormLine({ className, ...props }: FormLineProps) {
  const classes = className
    ? `${formStyles.line} ${className}`
    : formStyles.line
  return <div className={classes} {...props} />
}

type FormMiniProps = ComponentPropsWithoutRef<'div'>

export function FormMini({ className, ...props }: FormMiniProps) {
  const classes = className
    ? `${formStyles.formMini} ${className}`
    : formStyles.formMini
  return <div className={classes} {...props} />
}

type FormLegendProps = ComponentPropsWithoutRef<'div'>

export function FormLegend({ className, ...props }: FormLegendProps) {
  const classes = className
    ? `${formStyles.legend} ${className}`
    : formStyles.legend
  return <Text variant="legend" className={classes} {...props} />
}

type FormFieldProps<E extends ElementType> = {
  as?: E
  className?: string
  round?: boolean
  inputRef?: Ref<unknown>
} & ComponentPropsWithoutRef<E>

export function FormField<E extends ElementType = 'input'>({
  as,
  className,
  round,
  inputRef,
  ...props
}: FormFieldProps<E>) {
  const Component = (as || 'input') as ElementType
  const classes = [
    formStyles.field,
    round ? formStyles.roundField : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ')
  return <Component ref={inputRef} className={classes} {...props} />
}
